// DATEDAY (2026-10-26): a date-only value is shown as exactly its calendar day, in every timezone.
//
// THE CAUSE. `new Date("2026-10-02")` is MIDNIGHT UTC by the JavaScript specification (a date-only
// ISO string is read as UTC, a date-time string without an offset as local time). Formatting that
// instant with toLocaleDateString() in a browser west of UTC (any American timezone) gives the
// evening before: 01/10/2026. The value the portal stores is right; only the display was a day early.
// London and every Enko entity's timezone are at UTC or east of it, so they never showed the shift.
//
// THE RULE. A string that is exactly YYYY-MM-DD is read as that day at local midnight, so formatting
// it gives that day whatever the timezone and the season. Anything else (a date-time, a Date, a
// number) is passed to `new Date` exactly as before, so no date-time display changes.

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

export function toDisplayDate(value) {
  if (typeof value === 'string') {
    const m = DATE_ONLY.exec(value);
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }
  return new Date(value);
}

// Today's calendar day in the browser's own timezone, as YYYY-MM-DD. `new Date().toISOString()` is
// the UTC day, which is yesterday just after midnight east of UTC (and in London in summer) and
// tomorrow in the evening west of UTC.
export function todayISO(now = new Date()) {
  const p = (n) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())}`;
}
